import loadable from '@loadable/component';

export const ThankYouPage = loadable(/* #__LOADABLE__ */ () => import('./ThankYouPage'));
